@if (isFinal === true) {
<span
  class="inline-flex items-center rounded-full bg-forest px-3 py-1 text-xs font-semibold text-white"
  >Final</span
>
} @else {
<span
  class="inline-flex items-center rounded-full bg-base-300 px-3 py-1 text-xs font-semibold text-midnight"
  >Draft</span
>
}
